import ListGroup from 'react-bootstrap/ListGroup';
import {useSelector} from "react-redux";
import React, {useState} from "react";
import Table from 'react-bootstrap/Table';
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {ResponseAllTResponsibility} from "../../ticketsystem/API/response/ticket";
import Card from 'react-bootstrap/Card';
import ProgressBar from 'react-bootstrap/ProgressBar';
import Form from 'react-bootstrap/Form';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import {ResponseAllPlaner} from "../API/response/worktimetracking";
import {init2} from "../../../@WUM/core/form-serilizer/seriliaze/Formserialize";
import {getToken, Month} from "../../../@WUM/core/Function/index";
import {ApiURL, IntlMessageValue, setMonth, UniRow} from "../../../@WUM/core/Elements/index";
import {daysInMonth0, formatISODate} from "./PlanerComponents/Helpers/dateHelpers";
import {UniCol} from "../../../@WUM/core/Elements";
import {ColorMaker} from "./Configs/ColorMaker";
import {LegendList} from "./PlanerComponents/Elements/LegendList";
import {ResponseSettings} from "../API/response/settingstimetracking";
import UniAutocomplete, {UniAutocompleteItem} from "../../../@WUM/core/Elements/Form/Elements/UniAutocomplete";
import {responsibilityApiTYpe} from "../../ticketsystem/API/request/responsibility.Api,interface";
const Userplaner = (props:{value:any}) => {
    const Store = useSelector((state: any) => state)
    const today = new Date();

    const [year, setYear] = useState(today.getFullYear());
    const [months, setMonths] = useState(today.getMonth());
    const [working, setWorking] = useState(true);
    const [vacation, setVacation] = useState(true);
    const [sick, setSick] = useState(true);
    const [fetchData, setFetchData] = useState(0);
    const NameIndays = (year:any, month:any,day:any) => new Date(year, month, day).getDay();
    const [selectedUsers, setSelectedUsers] = useState<UniAutocompleteItem[]>([]);
    const [selectedDepartments, setSelectedDepartments] = useState<UniAutocompleteItem[]>([]);

    const response = ResponseAllPlaner(fetchData);

    const isToday = (y: number, m: number, d: number): boolean => {
        return (
            y === today.getFullYear() &&
            m === today.getMonth() &&
            d === today.getDate()
        );
    };

    const toPrivacyMode = (mode: string) => (mode === 'working' ? 'working' : 'absent');

    const days = ['day.short.sunday', 'day.short.monday', 'day.short.tuesday', 'day.short.wednesday', 'day.short.thursday', 'day.short.friday', 'day.short.saturday'];
    let TheadHolder = [];

    for(let d=1;d<=daysInMonth0(year, months);d++){
        const isTodayFlag = isToday(year, months, d);
        TheadHolder.push(
            <th className={isTodayFlag ? 'planer-today' : ''}><span className={"fw-normal"}>{IntlMessageValue('de',days[NameIndays(year, months,d)],Store)}</span> <br/> <span className={"fw-medium"}>{d}</span></th>
        )
    }
    let AllUSer = ResponseAllTResponsibility(fetchData)

    let Data: string | any[] = [];
    if (typeof response !== "boolean" && response?.length > 0) {
        Data = response
    }

    const HoverElement = (prefex:any,id:any,clear:any=false) => {
        let tmp = document.getElementById(prefex+''+id) as HTMLDivElement;
        if(tmp !== null) {
            if(clear === false) {
                tmp.style.display = 'block'
            } else {
                tmp.style.display = 'none'
            }

        }
    }

    const Mode = (mode:any) => {
        switch (mode) {
            case 'vacation':
                if (vacation === true) {
                    return true;
                } else {
                    return false;
                }
            case 'sick':
                if (sick === true) {
                    return true;
                } else {
                    return false;
                }
            case 'working':
                if (working === true) {
                    return true;
                } else {
                    return false;
                }
            case 'unapologetic':

                return true;

            case 'absent':

                return true;

            case 'training':
                return true;

        }
    }

    let USerRow = [];
    let UserHolderOption = [];
    let DepartmentHolderOption: UniAutocompleteItem[] = [];

    if (typeof response !== "boolean") {
        if (AllUSer !== true && typeof AllUSer !== "boolean" && AllUSer?.length > 0) {

            const users = AllUSer as responsibilityApiTYpe[];

            const usersByDepartment: Record<string, responsibilityApiTYpe[]> = {};

            users.forEach((user) => {
                const deptKey = user.department || 'notAssigned'; // Fallback-Label
                if (!usersByDepartment[deptKey]) {
                    usersByDepartment[deptKey] = [];
                }
                usersByDepartment[deptKey].push(user);
            });

            const departmentKeys = Object.keys(usersByDepartment).sort((a, b) => {
                // "notAssigned" immer ans Ende
                if (a === 'notAssigned' && b !== 'notAssigned') return 1;
                if (b === 'notAssigned' && a !== 'notAssigned') return -1;

                // Rest alphabetisch (optional)
                return a.localeCompare(b, 'de');
            });

            DepartmentHolderOption = departmentKeys.map((departmentKey) => ({
                value: departmentKey,
                text: IntlMessageValue('de', departmentKey, Store),
            }));

            for (let depIndex = 0; depIndex < departmentKeys.length; depIndex++) {
                const departmentKey = departmentKeys[depIndex];
                const departmentUsers = usersByDepartment[departmentKey];

                const isDepartmentSelected =
                    selectedDepartments.length === 0 ||
                    selectedDepartments.some((item) => item.value === departmentKey);

                if (!isDepartmentSelected) {
                    continue;
                }

                let DayArea = [];

                for (let d = 1; d <= daysInMonth0(year, months); d++) {
                    const isTodayFlag = isToday(year, months, d);
                    DayArea.push(
                        <>
                            <td className={`text-center bg-light border-0 ${isTodayFlag ? 'planer-today' : ''}`}
                            ></td>
                        </>
                    )

                }

                // Header-Row für die Abteilung
                USerRow.push(
                    <tr key={`dep-${departmentKey}`}>
                        <td
                            className="bg-light fw-semibold  border-0"
                        >
                            {IntlMessageValue('de', departmentKey, Store)}
                        </td>
                        {DayArea}
                    </tr>
                );

                for (let us = 0; us < departmentUsers?.length; us++) {
                    const user = departmentUsers[us];

                    // User-Filter (Mitarbeiter-Auswahl)
                    const isUserSelected =
                        selectedUsers.length === 0 ||
                        selectedUsers.some((item) => item.value === String(user.id));

                    // Department-Filter (Bereich-Auswahl)
                    const isDepartmentSelected =
                        selectedDepartments.length === 0 ||
                        selectedDepartments.some((item) => item.value === departmentKey);


                    UserHolderOption.push({
                        value: String(user.id),
                        text: user.username,
                    });

                    // Wenn einer der Filter nicht matched → User für diese Ansicht überspringen
                    if (!isUserSelected || !isDepartmentSelected) {
                        continue;
                    }
                    let UserHolder = [];


                    UserHolder.push(
                        <>
                            <td style={{background: (user.id == localStorage.getItem('userid') ? '#E5F1FD' : '')}}>
                                <img
                                    src={user.media || '/assets/avatarPlaceholder.png'}
                                    alt={user.username}
                                    className="rounded-circle me-2"
                                    style={{width: '30px', height: '30px', objectFit: 'cover'}}
                                    onError={(e: any) => {
                                        e.target.src = '/assets/avatarPlaceholder.png';
                                    }}
                                />
                                {user.username}
                            </td>
                        </>
                    )

                    for (let d = 1; d <= daysInMonth0(year, months); d++) {
                        const isTodayFlag = isToday(year, months, d);

                        let set = true;
                        for (let da = 0; da < Data.length; da++) {
                            if (Data[da].year == year && Data[da].month == months && Data[da].day == d && user.id == Data[da].userid) {

                                const displayMode = toPrivacyMode(Data[da].mode);
                                if (displayMode === 'working' ? working : true) {

                                    set = false;
                                    let userid = user.id

                                    UserHolder.push(
                                        <td className={`text-center ${isTodayFlag ? 'planer-today' : ''}`} style={{
                                            position: 'relative',
                                            background: (userid == localStorage.getItem('userid') ? '#E5F1FD' : '')
                                        }}>
                                <span className="material-icons position-absolute top-50 start-50 translate-middle"
                                      onMouseLeave={() => HoverElement(d + 'user', userid, true)}
                                      onMouseOver={() => HoverElement(d + 'user', userid)} style={{
                                    background: ColorMaker(toPrivacyMode(Data[da].mode)).bg,
                                    borderRadius: '50%',
                                    color: ColorMaker(toPrivacyMode(Data[da].mode)).bg
                                }}>
                                    radio_button_unchecked
                                </span>
                                            <Card id={d + 'user' + userid} className={'arrowBottom'} style={{
                                                width: '18rem',
                                                position: 'absolute',
                                                bottom: '60px',
                                                left: '-105px',
                                                display: 'none',
                                                background: '#343232',
                                                color: 'white',
                                                zIndex: 9999,
                                            }}>
                                                <Card.Body className={'pb-1 pt-2'}>
                                                    <Card.Title>{user.username}</Card.Title>
                                                    <Card.Text>
                                                        {
                                                            <>
                                                                {IntlMessageValue('de', 'wtp.' + toPrivacyMode(Data[da].mode), Store)}<br/>
                                                            </>
                                                        }
                                                    </Card.Text>
                                                </Card.Body>
                                            </Card>
                                        </td>
                                    )
                                }
                            }
                        }
                        if (set === true) {
                            let userid = user.id
                            UserHolder.push(
                                <>
                                    <>
                                        <td className={`text-center ${isTodayFlag ? 'planer-today' : ''}`}
                                            style={{background: (userid == localStorage.getItem('userid') ? '#E5F1FD' : '')}}></td>
                                    </>
                                </>
                            )
                        }

                    }
                    USerRow.push(
                        <>
                            <tr>
                                {UserHolder}
                            </tr>
                        </>
                    )
                }
            }


        }
        const setActiveList = (x:any,e:any) => {

            for(let m=0;m<Month.length;m++) {
                let tmp = document.getElementById(m+'month') as HTMLDivElement;
                if(tmp !== null) {
                    tmp.style.background = 'white';
                }

            }

            let tmps = e.target as HTMLDivElement;
            if(tmps !== null) {
                setMonths(x)
                tmps.style.background = '#B3FFBF';
            }

        }

        let MonthHoler = [];

        for(let x=0;x<Month.length;x++) {
            MonthHoler.push(
                <ListGroup.Item id={x+'month'} style={{background:(months === x ? '#B3FFBF' : 'white')}} onClick={(e)=>setActiveList(x,e)}>{setMonth(x,Store)}</ListGroup.Item>
            )
        }

        return(
            <div className={"m-3 planer"}>
                <div
                    className={"d-flex flex-row bg-white border border-1 border-secondary-subtle rounded-lg p-2 align-items-center gap-3 mb-3 justify-content-between"}>
                    <div className={"d-flex flex-row "}>
                        <h3>Planer</h3>
                        <LegendList
                            items={['working', 'vacation', 'sick', 'unapologetic', 'absent', 'training']}
                            labelFn={IntlMessageValue}
                            store={Store}
                            className={"ms-2"}
                        />
                    </div>
                </div>

                <UniRow
                    class={"bg-white border border-1 border-secondary-subtle rounded-lg py-2 align-items-center gx-0  mb-3"}>
                    <UniCol lg={6} xs={12}>
                        <div className={"px-2"}>
                            <UniAutocomplete
                                items={UserHolderOption}
                                onChange={(values) => setSelectedUsers(values)}
                                placeholder="Mitarbeiter auswählen"
                                class="mb-0"
                            />
                        </div>
                    </UniCol>
                    <UniCol lg={6} xs={12}>
                        <div className={"px-2"}>
                            <UniAutocomplete
                                items={DepartmentHolderOption}
                                onChange={(values) => setSelectedDepartments(values)}
                                placeholder="Bereich wählen"
                                class="mb-0"
                            />
                        </div>
                    </UniCol>
                </UniRow>
                <div
                    className={"bg-white border border-1 border-secondary-subtle rounded-lg p-2 align-items-center gap-3 mb-3"}>


                    <Row className={'p-2 mx-0'} style={{background: '#E5E5E5'}}>
                        <Col className={'col-2 pr-1'}>
                            <Row>
                                <Col>
                                    <Button variant="primary" className={'ml-2 prevforButton'}
                                            onClick={() => setYear(year - 1)}>
                        <span className="material-icons" style={{fontSize: '12px'}}>
                            arrow_back_ios
                        </span>
                                    </Button>
                                </Col>
                                <Col>
                                    <p className={'pt-2'}>{year}</p>
                                </Col>
                                <Col>
                                    <Button variant="primary" className={'ml-2 mr-2 prevforButton'}
                                            onClick={() => setYear(year + 1)}>
                        <span className="material-icons" style={{fontSize: '12px'}}>
                            arrow_forward_ios
                        </span>
                                    </Button>
                                </Col>
                            </Row>
                        </Col>
                        <Col className={'col-8 pl-1 pr-1 text-center'} style={{marginLeft: '-15px'}}>
                            <ListGroup horizontal>
                                {MonthHoler}
                            </ListGroup>
                        </Col>

                        <Col className={'col-2'}>
                            <Row>
                                <Col className={'pl-1 pr-1 pt-2'}>

                                    <Form.Check
                                        onChange={(e) => setWorking(e.target.checked)}
                                        checked={working}
                                        className={'float-start mr-2'}
                                        label={IntlMessageValue('de', 'wtp.working', Store)}
                                        name="group1"
                                        type={'checkbox'}
                                        id={`reverse-1`}
                                    />


                                    <Form.Check
                                        onChange={(e) => {
                                            setSick(e.target.checked);
                                            setVacation(e.target.checked);
                                        }}
                                        checked={sick && vacation}
                                        className={'float-start  mr-2'}
                                        label={IntlMessageValue('de', 'wtp.absent', Store)}
                                        name="group1"
                                        type={'checkbox'}
                                        id={`reverse-2`}
                                    />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Table bordered hover>
                        <thead>
                        <tr>
                            <th style={{maxWidth: "190px"}}>

                            </th>
                            {TheadHolder}
                        </tr>
                        </thead>
                        <tbody className={"small-table-icon"}>
                        {USerRow}
                        </tbody>
                    </Table>

                </div>
            </div>
                )
                } else {
                return (
                <></>
                )
            }
                }

                export default Userplaner;
